module.exports = __webpack_public_path__ + "img/SMT_07_Mr_Kelvin_Lim.a60a255c.jpg";